import { startTransition } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import App from './App.tsx'
import { routes } from './routes'
import './index.css'

const container = document.getElementById("root")!;

/**
 * HIDRATA o HTML do SSG em vez de recriar a página (2026-10-23).
 *
 * Até aqui o cliente fazia createRoot().render(): jogava fora o HTML pronto e
 * montava tudo de novo. Num celular médio isso custava a página inteira duas
 * vezes (estilo, layout e pintura) logo no carregamento, e todas as animações
 * de entrada recomeçavam no meio.
 *
 * Só hidrata quando o HTML é DESTA rota. A Cloudflare serve o index.html da
 * home para qualquer caminho desconhecido (/r/<slug>, 404 — ver
 * public/_redirects); hidratar a home com outra página no lugar daria erro de
 * hidratação. Nesses casos segue o caminho antigo, montando do zero.
 *
 * startTransition: a hidratação vira trabalho interrompível — se a pessoa tocar
 * num botão no meio, o toque vem primeiro.
 */
const semBarraFinal = (p: string) => (p.length > 1 ? p.replace(/\/+$/, "") : p);
const rotasDoSsg = routes
  .map((r) => r.path)
  .filter((p): p is string => !!p && !p.includes(":") && !p.includes("*"));
const htmlDestaRota =
  container.dataset.serverRendered === "true" &&
  rotasDoSsg.includes(semBarraFinal(window.location.pathname));

if (htmlDestaRota) {
  startTransition(() => {
    hydrateRoot(container, <App hidratando />);
  });
} else {
  createRoot(container).render(<App />);
}
